import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import ModuleTemplate from '../../ModuleTemplate'; 

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/vision/segen/';
const BOARD_IMAGE = S3_BASE_URL + 'board.png';

const INACTIVITY_TIMEOUT = 60000;


const shapeCategory = (shapeId) => shapeId.split('_')[0];

// ТОЧНЫЕ КООРДИНАТЫ ИЗ PYTHON
const ASPECT_RATIO = "1104 / 591";
const BOARD_MAP = [
  { id: "red_square", left: 3.5326, top: 6.599, width: 15.4891, height: 28.934 },
  { id: "green_circle", left: 19.0217, top: 6.599, width: 15.4891, height: 28.934 },
  { id: "orange_diamond", left: 34.5109, top: 6.599, width: 15.4891, height: 28.934 },
  { id: "yellow_triangle_up", left: 50.0, top: 6.599, width: 15.4891, height: 28.934 },
  { id: "purple_hexagon", left: 65.4891, top: 6.599, width: 15.4891, height: 28.934 },
  { id: "blue_oval", left: 80.9783, top: 6.599, width: 15.4891, height: 28.934 },
  { id: "red_oval", left: 3.5326, top: 35.533, width: 15.4891, height: 28.934 },
  { id: "yellow_hexagon", left: 19.0217, top: 35.533, width: 15.4891, height: 28.934 },
  { id: "blue_square", left: 34.5109, top: 35.533, width: 15.4891, height: 28.934 },
  { id: "purple_circle", left: 50.0, top: 35.533, width: 15.4891, height: 28.934 },
  { id: "green_diamond", left: 65.4891, top: 35.533, width: 15.4891, height: 28.934 },
  { id: "green_triangle_down", left: 80.9783, top: 35.533, width: 15.4891, height: 28.934 },
  { id: "orange_hexagon", left: 3.5326, top: 64.467, width: 15.4891, height: 28.934 },
  { id: "red_diamond", left: 19.0217, top: 64.467, width: 15.4891, height: 28.934 },
  { id: "blue_circle", left: 34.5109, top: 64.467, width: 15.4891, height: 28.934 },
  { id: "yellow_square", left: 50.0, top: 64.467, width: 15.4891, height: 28.934 },
  { id: "purple_triangle_down", left: 65.4891, top: 64.467, width: 15.4891, height: 28.934 },
  { id: "orange_oval", left: 80.9783, top: 64.467, width: 15.4891, height: 28.934 }
];

// Массив только с именами (нужен, чтобы раскидать фигурки по бокам)
const SHAPE_IDS = BOARD_MAP.map(cell => cell.id);

const handleImageError = (e, shapeId) => {
  console.warn(`[SeguinBoard] Не загрузилась картинка фигуры "${shapeId}": ${e.target.src}`);
  e.target.style.display = 'none';
  if (e.target.parentElement) {
    e.target.parentElement.style.border = '2px dashed #EF4444';
    e.target.parentElement.style.background = 'rgba(239,68,68,0.08)';
  }
};

const SeguinBoard = ({ onBack, onComplete }) => {
  const [placedShapes, setPlacedShapes] = useState({});
  const [selectedShape, setSelectedShape] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [wrongCell, setWrongCell] = useState(null);
  const [errorLog, setErrorLog] = useState([]);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

   const totalShapes = BOARD_MAP.length;
  const placedCount = Object.keys(placedShapes).filter(k => placedShapes[k]).length;
  const inactivityTimerRef = useRef(null);

  // Рефы-зеркала стейта — нужны, чтобы handleStopClick всегда видел АКТУАЛЬНЫЙ прогресс
  // на момент клика (а не значение, "замороженное" в старом замыкании кнопки).
  const placedShapesRef = useRef(placedShapes);
  const errorLogRef = useRef(errorLog);
  useEffect(() => { placedShapesRef.current = placedShapes; }, [placedShapes]);
  useEffect(() => { errorLogRef.current = errorLog; }, [errorLog]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const { leftShapes, bottomShapes, rightShapes } = useMemo(() => {
    const shuffled = [...SHAPE_IDS].sort(() => Math.random() - 0.5);
    return {
      leftShapes: shuffled.slice(0, 6),
      bottomShapes: shuffled.slice(6, 12),
      rightShapes: shuffled.slice(12, 18)
    };
  }, []);

   const sizes = useMemo(() => {
    if (windowWidth < 400) {
      return { shapeSize: 54, cellSize: 54, boardGap: 2, shapeGap: 4, isMobile: true, boardWidth: '100%', mainGap: '12px' };
    }
    if (windowWidth < 500) {
      return { shapeSize: 60, cellSize: 60, boardGap: 2, shapeGap: 5, isMobile: true, boardWidth: '100%', mainGap: '14px' };
    }
    if (windowWidth < 640) {
      return { shapeSize: 68, cellSize: 68, boardGap: 3, shapeGap: 6, isMobile: true, boardWidth: '100%', mainGap: '16px' };
    }
    if (windowWidth < 900) {
      return { shapeSize: 76, cellSize: 78, boardGap: 4, shapeGap: 7, isMobile: false, boardWidth: '420px', mainGap: '20px' };
    }
    if (windowWidth < 1100) {
      return { shapeSize: 82, cellSize: 84, boardGap: 6, shapeGap: 9, isMobile: false, boardWidth: '480px', mainGap: '25px' };
    }
    return {
      shapeSize: 88, cellSize: 90, boardGap: 8, shapeGap: 10, isMobile: false, boardWidth: '550px', mainGap: '30px',
    };
  }, [windowWidth]);

  const allShapesMobile = useMemo(() => 
    [...leftShapes, ...bottomShapes, ...rightShapes], 
    [leftShapes, bottomShapes, rightShapes]
  );

  // Единая точка сборки результата — используется и при автозавершении (все 18 фигур на месте),
  // и при досрочной остановке кнопкой СТОП (фигур может быть размещено меньше, чем всего).
  // Раньше при досрочном СТОП вызывался "сырой" onComplete без данных, и прогресс терялся целиком —
  // теперь результат всегда считается от РЕАЛЬНОГО количества размещённых фигур на момент вызова.
  const buildResultPayload = useCallback((currentPlacedShapes, currentErrorLog) => {
    const correctCount = Object.keys(currentPlacedShapes).filter(k => currentPlacedShapes[k]).length;
    const score = totalShapes > 0 ? Math.round((correctCount / totalShapes) * 100) : 0;

    const shapesWithErrors = new Set(currentErrorLog.map(e => e.targetShapeId));
    const firstTryCorrectCount = totalShapes - shapesWithErrors.size;

    const confusionPairs = [];
    const seenPairs = new Set();
    currentErrorLog.forEach(({ targetShapeId, attemptedShapeId }) => {
      const target = shapeCategory(targetShapeId);
      const attempted = shapeCategory(attemptedShapeId);
      const key = `${target}->${attempted}`;
      if (!seenPairs.has(key)) {
        seenPairs.add(key);
        confusionPairs.push({ target, attempted });
      }
    });

    return {
      testId: 'SeguinBoard',
      score,
      details: {
        total: totalShapes,
        correct: correctCount,
        firstTryCorrectCount,
        retriedCount: shapesWithErrors.size,
        confusionPairs,
        // Флаг для отчёта: упражнение остановлено до того, как были размещены все фигуры
        // (нажата кнопка СТОП или истёк таймаут бездействия).
        completedEarly: correctCount < totalShapes,
      },
    };
  }, [totalShapes]);

  const finishExercise = useCallback(() => {
    if (isCompleted) return;
    clearTimeout(inactivityTimerRef.current);
    setIsCompleted(true);
  }, [isCompleted]);

  const resetInactivityTimer = useCallback(() => {
    clearTimeout(inactivityTimerRef.current);
    inactivityTimerRef.current = setTimeout(() => {
      finishExercise();
    }, INACTIVITY_TIMEOUT);
  }, [finishExercise]);

  useEffect(() => {
    resetInactivityTimer();
    return () => clearTimeout(inactivityTimerRef.current);
  }, [resetInactivityTimer]);

  useEffect(() => {
    if (placedCount === totalShapes && totalShapes > 0 && !isCompleted) {
      finishExercise();
    }
  }, [placedCount, totalShapes, isCompleted, finishExercise]);

  useEffect(() => {
    if (!isCompleted) return;
    const timer = setTimeout(() => {
      const payload = buildResultPayload(placedShapesRef.current, errorLogRef.current);
      if (onComplete) {
        onComplete(payload);
      } else {
        onBack();
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [isCompleted, buildResultPayload, onComplete, onBack]);

  // Обработчик кнопки СТОП: фиксирует РЕАЛЬНЫЙ прогресс на момент нажатия
  // (например, 5 из 18 или 10 из 18 фигур), а не отбрасывает его.
  const handleStopClick = useCallback(() => {
    clearTimeout(inactivityTimerRef.current);
    const payload = buildResultPayload(placedShapesRef.current, errorLogRef.current);
    if (onComplete) {
      onComplete(payload);
    } else if (onBack) {
      onBack();
    }
  }, [buildResultPayload, onComplete, onBack]);

  const handleSelectShape = (shapeId) => {
    if (placedShapes[shapeId]) return;
    resetInactivityTimer();
    setSelectedShape(prev => prev === shapeId ? null : shapeId);
  };

  const triggerError = (cellIndex) => {
    setWrongCell(cellIndex);
    setTimeout(() => setWrongCell(null), 400);
  };

  const handlePlaceShape = (requiredShapeId, index) => {
    if (!requiredShapeId || placedShapes[requiredShapeId]) return;
    resetInactivityTimer();
    if (selectedShape === requiredShapeId) {
      setPlacedShapes(prev => ({ ...prev, [requiredShapeId]: true }));
      setSelectedShape(null);
    } else if (selectedShape) {
      setErrorLog(prev => [...prev, { targetShapeId: requiredShapeId, attemptedShapeId: selectedShape }]);
      triggerError(index); 
    }
  };

  const handleDragStart = (e, shapeId) => {
    e.dataTransfer.setData('text/plain', shapeId);
    resetInactivityTimer();
    setSelectedShape(shapeId);
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = (e, requiredShapeId, index) => {
    e.preventDefault();
    resetInactivityTimer();
    const draggedId = e.dataTransfer.getData('text/plain');
    if (draggedId === requiredShapeId && !placedShapes[requiredShapeId]) {
      setPlacedShapes(prev => ({ ...prev, [requiredShapeId]: true }));
    } else if (draggedId && draggedId !== requiredShapeId) {
      setErrorLog(prev => [...prev, { targetShapeId: requiredShapeId, attemptedShapeId: draggedId }]);
      triggerError(index); 
    }
    setSelectedShape(null);
  };

  const renderShapeSlot = (shapeId) => {
    const isPlaced = placedShapes[shapeId];
    const isSelected = selectedShape === shapeId;

    if (isPlaced) {
      return <div key={shapeId} style={{ width: sizes.shapeSize, height: sizes.shapeSize }} />;
    }

    return (
      <div
        key={shapeId}
        draggable
        onDragStart={(e) => handleDragStart(e, shapeId)}
        onClick={() => handleSelectShape(shapeId)}
        style={{
          width: sizes.shapeSize,
          height: sizes.shapeSize,
          backgroundColor: '#fff',
          borderRadius: sizes.isMobile ? '8px' : '12px',
          border: isSelected ? '3px solid #7B4EF8' : '3px solid transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'grab',
          transform: isSelected ? 'scale(1.1)' : 'scale(1)',
          transition: 'all 0.2s ease',
          boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
          flexShrink: 0,
        }}
      >
        <img 
          src={S3_BASE_URL + shapeId + '.png'} 
          alt={shapeId}
          style={{ width: '95%', height: '95%', objectFit: 'contain' }}
          draggable={false} 
          onError={(e) => handleImageError(e, shapeId)}
        />
      </div>
    );
  };

      const renderBoard = () => (
    <div style={{
      width: sizes.boardWidth,
      aspectRatio: ASPECT_RATIO,
      backgroundImage: 'url(' + BOARD_IMAGE + ')',
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
      position: 'relative', 
      borderRadius: sizes.isMobile ? '10px' : '16px',
      boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
      zIndex: 2,
    }}>
      {BOARD_MAP.map((cell, index) => {
        const isPlaced = placedShapes[cell.id];
        const isError = wrongCell === index;

        return (
          <div
            key={cell.id}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, cell.id, index)}
            onClick={() => handlePlaceShape(cell.id, index)}
            style={{
              position: 'absolute', 
              left: cell.left + '%',
              top: cell.top + '%',
              width: cell.width + '%',
              height: cell.height + '%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: isPlaced ? 'default' : 'pointer',
              zIndex: 2,
              boxSizing: 'border-box',
              border: isError ? '3px solid #EF4444' : '3px solid transparent',
              transition: 'border 0.2s'
            }}
          >
            {isPlaced && (
              <img 
                src={S3_BASE_URL + cell.id + '.png'} 
                alt={cell.id}
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'contain', 
                  filter: 'drop-shadow(0px 2px 3px rgba(0,0,0,0.3))',
                  pointerEvents: 'none'
                }}
                draggable={false}
                onError={(e) => handleImageError(e, cell.id)}
              />
            )}
          </div>
        );
      })}
    </div>
  );

  if (isCompleted) {
    const correctCount = placedCount;
    const score = Math.round((correctCount / totalShapes) * 100);

    return (
      <ModuleTemplate 
        progress={Array(totalShapes).fill(true)} 
        totalQuestions={totalShapes} 
        forceStop={true}             
        onComplete={onComplete}      
      >
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="score-total"> / {totalShapes}</span>
          </div>
          <div style={{ fontFamily: 'Inter', fontSize: '20px', color: '#4A4A5A', marginTop: '10px' }}>
            Результат: {score}%
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  if (sizes.isMobile) {
    return (
      <ModuleTemplate 
        progress={Array(placedCount).fill(true)} 
        totalQuestions={totalShapes} 
        forceStop={true}             
        onComplete={handleStopClick}      
      >
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          width: '100%', 
          gap: sizes.mainGap,
          padding: '0 8px'
        }}>
          {renderBoard()}
          
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: sizes.shapeGap + 'px',
            justifyContent: 'center',
          }}>
            {allShapesMobile.map(shape => renderShapeSlot(shape))}
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  return (
    <ModuleTemplate 
      progress={Array(placedCount).fill(true)} 
      totalQuestions={totalShapes} 
      forceStop={true}             
      onComplete={handleStopClick}      
    >
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        width: '100%', 
        height: '100%', 
        gap: sizes.mainGap 
      }}>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gridTemplateRows: '1fr 1fr 1fr', 
          gap: sizes.shapeGap + 'px' 
        }}>
          {leftShapes.map(shape => renderShapeSlot(shape))}
        </div>

        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: sizes.mainGap 
        }}>
          {renderBoard()}

          <div style={{ display: 'flex', gap: sizes.shapeGap + 'px' }}>
            {bottomShapes.map(shape => renderShapeSlot(shape))}
          </div>
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gridTemplateRows: '1fr 1fr 1fr', 
          gap: sizes.shapeGap + 'px' 
        }}>
          {rightShapes.map(shape => renderShapeSlot(shape))}
        </div>
      </div>
    </ModuleTemplate>
  );
};

export default SeguinBoard;